// Disable Quick View / Quick Add overlay for product cards
document.addEventListener('DOMContentLoaded', () => {
  // Remove hover quick-view buttons
  const quickviews = document.querySelectorAll('.product-card-quickview, quick-view');
  quickviews.forEach(el => el.remove());

  // Prevent re-adding via event listeners
  const observer = new MutationObserver(() => {
    document.querySelectorAll('.product-card-quickview, quick-view').forEach(el => el.remove());
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
